module.exports = Vue;


//////////////////
// WEBPACK FOOTER
// external "Vue"
// module id = 86
// module chunks = 0